import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import DeliveryLayout from "../../components/Layout/DeliveriesLayout";
import classes from './Mfa.module.sass';
import SmsCodeForm from './SmsCodeForm';
import { actionCreators as userActionCreators } from "../../data/user/actions";
import { SET_SERVER_AUTH } from '../../data/user/actions';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import Auth0 from '../../store/actions/auth/Auth';

const Mfa = () => {
    const { t } = useTranslation('verify');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    
    const smsCode = useSelector(state => state.user.smsCode || false);
    
    const [smsCodeRequested, setSmsCodeRequested] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [formCode, setFormCode] = useState(false); 
    const verifyRef = useRef(null);

    // Parse query parameters to get returnUrl
    const queryParams = new URLSearchParams(location.search);
    const returnUrl = queryParams.get('returnUrl') || "/"; // Default to home page

    const isAuth0Authenticated = Auth0.isAuthenticated();
    const serverAuthenticated = useSelector(state => state.user.serverAuthenticated);

    useEffect(() => {
        if (!isAuth0Authenticated) {
            navigate('/', { replace: true });
        }
    }, [isAuth0Authenticated, navigate]);

    useEffect(() => {
        if (serverAuthenticated === true) {
            navigate(returnUrl, { replace: true });
        }
    }, [serverAuthenticated, navigate, returnUrl]);

    const getSmsCode = async () => {
        setSmsCodeRequested(true);
        try {
            const res = await axios.get('/api/authenticationCode', {
                headers: { 
                    "Authorization": `Bearer ${Auth0.getAccessToken()}` 
                }
            });
            if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
                console.log('auth code', res);
                alert(res.data.authCode);
            }
        } catch (err) {
            console.error(err);
            setErrorMessage(t("smsverify.requestError"));
        }        
    };

    const handleVerify = async () => {
    setErrorMessage("");
    try {
        await axios.post('/api/authenticate', { authCode: formCode }, {
            headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
        });
        dispatch(userActionCreators.setSmsCode(formCode));
        dispatch({ type: SET_SERVER_AUTH, payload: true });
        navigate(returnUrl, { replace: true });
    } catch (err) {
        console.error(err);
        const errorCode = err?.response?.data?.errorCode;
        if (errorCode === 24) {
        setErrorMessage(t("smsverify.lockedOutError"));
        } else {
        setErrorMessage(t("smsverify.validateError"));
        }
    }
    };

    const handleFormFilled = (code) => {
        setFormCode(code);        
        setTimeout(() => {
            if (verifyRef.current) {
                verifyRef.current.focus();
            }
        }, 0);
    };

    const handleRequestNewCode = () => {
        setErrorMessage("");
        setSmsCodeRequested(false);
        setFormCode(false);
    };

    return (
        <DeliveryLayout>            
            <div className={classes["mfa-wrapper"]}>
                <div className={classes["mfa_contentWrapper"]}>
                    <h2>{t('smsverify.header')}</h2>
                    <p>{t('smsverify.label')}</p>
                    {!smsCodeRequested && (
                        <button                 
                            className="btn btn--primary" 
                            onClick={getSmsCode}
                        >
                            {t('smsverify.sendSmsButton')}
                        </button>
                    )}
                    {smsCodeRequested && (
                        <div>                                                
                            <SmsCodeForm 
                                onFilled={handleFormFilled} 
                                autoFocus={true} 
                            />   
                            {errorMessage && (
                                <p className={classes.error}>{errorMessage}</p>
                            )}
                            <div className={classes["mfa_buttons"]}>
                                <button 
                                    className="btn btn--secondary" 
                                    onClick={handleRequestNewCode}
                                >
                                    {t('smsverify.newSmsButton')}
                                </button>

                                <button  
                                    ref={verifyRef} 
                                    className="btn btn--primary" 
                                    disabled={!formCode} 
                                    onClick={handleVerify}
                                >
                                    {t('smsverify.proceedButton')}        
                                </button>
                            </div>         
                        </div>
                    )}
                    <div className={classes["mfa_help_text"]}>
                        {t('smsverify.smsProblemHelp')}                        
                    </div>
                </div>
            </div>
        </DeliveryLayout>
    );
};

export default Mfa;